<template>
    <div class="report-group-builder mb-5 mx-2">
        <h1 class="mb-3">Report Group Builder</h1>
        <div class="mb-3">
            <div class="card mb-3 table-card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <h3 class="mt-2">Report Groups ({{ filtered_groups.length }})</h3>
                        </div>
                        <div class="col-md-6 d-none d-md-block">
                            <div class="d-flex justify-content-end justify-self-end gap-2">
                                <div class="position-relative">
                                    <input 
                                        type="text" 
                                        placeholder="Search by Group Name..." 
                                        aria-label="Search by Group Name..." 
                                        v-model="search_key" 
                                        @input="handleFilterSelection" 
                                        autocomplete="one-time-code" 
                                        class="search-box form-control me-1 py-2"
                                    >
                                    <i class="fa fa-search search-placeholder-icon" v-show="search_key === ''"></i>
                                </div>
                                <a class="btn btn-primary float-end" href="/admin/report_group_builder/new">
                                    <i class="fa fas fa-fw fa-plus"></i> Add Report Group
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-body p-0">
                    <div class="table-width-responsive">
                        <table class="table table-with-pagination mb-0">
                            <thead>
                                <tr class="table-header-row">
                                    <th @click.prevent="sortByKey('group_name')" class="d-table-cell">
                                        <div class="d-flex flex-row">
                                            Group Name
                                            <div class="d-flex flex-column">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{ 'sort-key-active': sort_key === 'group_name' && sort_order === 'asc' }" alt="">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{ 'sort-key-active': sort_key === 'group_name' && sort_order === 'des' }" alt="">
                                            </div>
                                        </div>
                                    </th>
                                    <th @click.prevent="sortByKey('order')" class="d-table-cell">
                                        <div class="d-flex flex-row">
                                            Order
                                            <div class="d-flex flex-column">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{ 'sort-key-active': sort_key === 'order' && sort_order === 'asc' }" alt="">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{ 'sort-key-active': sort_key === 'order' && sort_order === 'des' }" alt="">
                                            </div>
                                        </div>
                                    </th>
                                    <!-- <th class="d-none d-md-table-cell">Reports</th> -->
                                    <th class="d-table-cell column-sort-disabled text-center pe-3" width="1">
                                        <div class="d-flex flex-row">Actions</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(group, index) in list_shown" :key="group.id">
                                    <td class="d-table-cell align-start">
                                        <a :href="`/admin/report_group_builder/${group.id}`">{{ group.group_name }}</a>
                                    </td>
                                    <td class="d-table-cell">
                                        {{ group.order }}
                                    </td>
                                    <!-- <td class="d-none d-md-table-cell">
                                        {{ group.report_count || 0 }}
                                    </td> -->
                                    <td class="table-column-action d-table-cell">
                                        <div class="dropdown d-flex justify-content-center">
                                            <button class="btn btn-white btn-icon-only-md" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false" aria-label="Button">
                                                <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" data-bs-toggle="tooltip" title="Actions" alt="" />
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                                <a class="dropdown-item" :href="`/admin/report_group_builder/${group.id}`">
                                                    <img class="icon me-2" src="/img/icons/avid-icons/edit.svg" alt=""> Edit Group
                                                </a>
                                                <hr class="my-1" />
                                                <a class="dropdown-item text-danger" href="#" @click.prevent="deleteGroup(group)">
                                                    <img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt=""> Delete Group
                                                </a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="list_shown.length === 0">
                                    <td colspan="4" class="text-center py-3">No report groups found. <a href="/admin/report_group_builder/new">Create your first report group</a>.</td>
                                </tr>
                            </tbody>
                            <tfoot class="table-border-bottom-0">
                                <tr>
                                    <td colspan="100%" class="py-0">
                                        <div class="table-pagination">
                                            <div class="table-pagination--group d-none d-md-flex">
                                                <div class="position-relative">
                                                    <select class="form-select" v-model="num_per_page" @update:modelValue="reloadPagination(filtered_groups)" aria-label="Num Per Page">
                                                        <option value="5000">ALL</option>
                                                        <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                    </select>
                                                    <div class="select-display-text">
                                                        Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="table-pagination--group d-none d-lg-flex">
                                                {{ filtered_groups.length == 0 ? '0' : item_interval }} of {{ filtered_groups.length }}
                                            </div>

                                            <div class="table-pagination--group">
                                                <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md me-1" @click.prevent="moveToPrevPage(filtered_groups)" :disabled="page_index === 0" data-bs-toggle="tooltip" title="Previous page">
                                                    <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
                                                </button>

                                                <div class="d-flex page-selector" v-if="page_index_array.length <= 3">
                                                    <button v-for="page in page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="page === (page_index + 1) ? 'current-page' : ''" @click.prevent="moveToPage(page, filtered_groups)">
                                                        {{ page }}
                                                    </button>
                                                </div>
                                                <div class="d-flex page-selector" v-else>
                                                    <button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="page === (page_index + 1) ? 'current-page' : ''" @click.prevent="moveToPage(page, filtered_groups)">
                                                        {{ page }}
                                                    </button>
                                                    <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>...</button>
                                                    <button v-if="page_index >= 2 && page_index < page_index_array.length -1" class="btn btn-none btn-icon-only-md current-page">
                                                        {{ page_index + 1 }}
                                                    </button>
                                                    <button v-if="page_index < page_index_array.length -2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">...</button>
                                                    <button :class="page_index === (page_index_array.length -1) ? 'current-page' : ''" class="btn btn-none btn-icon-only-md" @click.prevent="moveToPage(page_index_array.length, filtered_groups)" :key="page_index_array.length">
                                                        {{ page_index_array.length }}
                                                    </button>
                                                </div>

                                                <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md ms-1" @click.prevent="moveToNextPage(filtered_groups)" :disabled="page_index === page_count -1" data-bs-toggle="tooltip" title="Next page">
                                                    <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import tablePaginationMixin from '../../mixins/table_pagination';
import Swal from 'sweetalert2';
import { useNotifications } from '../../composables/useNotifications';

export default {
    name: 'ReportGroupBuilder',
    props: {
        reportGroups: {
            type: Array,
            default: () => []
        },
    },
    mixins: [tablePaginationMixin],
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    data() {
        return {
            filtered_groups: [],
            list_shown: [],
            search_key: '',
            sort_key: 'order',
            sort_order: 'asc'
        };
    },
    beforeMount() {
        this.filtered_groups = [...this.reportGroups];
        this.reloadPagination(this.filtered_groups);
    },
    methods: {
        handleFilterSelection() {
            const searchTerm = this.search_key.trim().toLowerCase();
            const filtered_list = this.reportGroups.filter(group => {
                if (!searchTerm) return true;
                return group.group_name.toLowerCase().includes(searchTerm);
            });

            this.filtered_groups = filtered_list;
            this.sortData();
            this.reloadPagination(this.filtered_groups);
        },
        sortByKey(key) {
            if (this.sort_key === key) {
                this.sort_order = this.sort_order === 'asc' ? 'des' : 'asc';
            } else {
                this.sort_key = key;
                this.sort_order = 'asc';
            }
            this.sortData();
        },
        sortData() {
            this.filtered_groups.sort((a, b) => {
                let comparison = 0;
                if (this.sort_key === 'order') {
                    comparison = a.order - b.order;
                } else {
                    const aVal = a[this.sort_key] || '';
                    const bVal = b[this.sort_key] || '';
                    comparison = aVal.toString().localeCompare(bVal.toString());
                }
                return this.sort_order === 'asc' ? comparison : -comparison;
            });
            this.reloadPagination(this.filtered_groups);
        },
        async deleteGroup(group) {
            const result = await Swal.fire({
                title: "Are you sure you want to delete this report group?",
                text: "This will remove the group_name from all associated report pages. This action cannot be undone.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it",
                customClass: {
                    popup: 'swal-warning'
                }
            });

            if (result.isConfirmed) {
                try {
                    await window.axios.delete(`/api/admin/report_group/${group.id}`);
                    
                    this.filtered_groups = this.filtered_groups.filter(g => g.id !== group.id);
                    this.reloadPagination(this.filtered_groups);

                    this.showNotification({
                        text: '<strong>' + group.group_name + '</strong> was deleted!'
                    });
                } catch (error) {
                    this.showNotification({
                        text: 'Failed to delete <strong>' + group.group_name + '</strong>. Please try again.',
                        type: 'error'
                    });
                }
            }
        }
    }
};
</script>
